import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { AxiosError } from 'axios'
import { SendAliasVerificationBody } from '@/types'
import { removeNonNumeric } from '@/helpers'

export async function sendAliasVerification(body: SendAliasVerificationBody) {
  const response = await httpClient('user-manager').post(
    '/v1/user/me/alias/send-verification',
    {
      ...body,
      alias: body.alias_type === 'phone' ? removeNonNumeric(body.alias) : body.alias,
    },
  )

  return response.data
}

export function useSendAliasVerification(
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    SendAliasVerificationBody,
    unknown
  >,
) {
  return useMutation({
    mutationFn: sendAliasVerification,
    ...options,
  })
}
